export enum AddCardStatus {
    // eslint-disable-next-line no-unused-vars
    ERROR = "Error",
    
    // eslint-disable-next-line no-unused-vars
    SUCCESS = "Success",
}